const BOARDS = [
  { id: 'board-business-strategy', name: 'Business Strategy' },
  { id: 'board-customer-revenue', name: 'Customer Revenue' },
  { id: 'board-product-gtm', name: 'Product & GTM' },
  { id: 'board-engineering', name: 'Engineering & Platform' },
  { id: 'board-security', name: 'Security & Compliance' },
  { id: 'board-finance', name: 'Finance & Planning' },
  { id: 'board-operations', name: 'Operations' },
  { id: 'board-data-ai', name: 'Data & AI' },
  { id: 'board-executive', name: 'Executive Briefings' },
]

export default BOARDS
